<template>
  <div class="modal">
    <!-- ヘッダー -->
    <div class="modal-header">
      <div class="modal-title">登録を解除しますか？</div>
      <Button class="modal-close-button" @click="switchModal">
        <v-ons-icon icon="fa-close" size="2rem" />
      </Button>
    </div>
    <!-- モニター情報 -->
    <img :src="monitorTypeIcon" class="monitor-image" alt="monitorTypeIcon" />
    <div class="monitor-information">
      <p class="monitor-information-detail">{{ deleteMoniterInformation.advertisementId }}</p>
      <div class="monitor-information-item">
        <p class="monitor-information-title">端末名</p>
        <p class="monitor-information-detail">{{ deleteMoniterInformation.monitorName }}</p>
      </div>
    </div>
    <div class="attention-note">解除すると再度ログインが<br />必要になります</div>
    <!-- フッター -->
    <div class="modal-footer">
      <outline-button
        title="キャンセル"
        :disabled="isAxiosWait"
        class="cancel-button"
        @click="switchModal"
      />
      <outline-danger-button
        title="解除する"
        :disabled="isAxiosWait"
        class="delete-button"
        @click="onClickMonitorDeleteButton"
      />
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue';
import OutlineDangerButton from '@/components/common/OutlineDangerButton.vue';
import OutlineButton from '@/components/common/OutlineButton.vue';
import Button from '@/components/common/Button.vue';
import { deleteMonitor } from '@/composable/data_push_common';

// props受け取り
const props = defineProps({
  switchModal: {
    type: Function,
    required: true,
  },
  getMonitorList: {
    type: Function,
    required: true,
  },
  deleteMoniterInformation: {
    type: Object,
    required: true,
  },
  monitorTypeIcon: {
    type: String,
    required: true,
  },
});

// axios処理待ち
const isAxiosWait = ref(false);

// 解除ボタン押下
const onClickMonitorDeleteButton = async () => {
  // 通信処理中の場合は処理中止
  if (isAxiosWait.value) return;
  isAxiosWait.value = true;
  try {
    // モニター解除処理
    await deleteMonitor(props.deleteMoniterInformation.monitorId);
    await props.getMonitorList();
    props.switchModal();
  } finally {
    isAxiosWait.value = false;
  }
};
</script>

<style scoped>
/** モーダル */
.modal {
  background: #fff;
  border-radius: 10px;
  height: 40%;
  margin: auto;
  color: #222;
  overflow: scroll;
  width: 80%;
  white-space: normal;
  border: 1px #ddd solid;
  max-width: 840px;
}
.modal-header {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 6rem;
}
.modal-title {
  font-size: 1.6rem;
  font-weight: 700;
}
.modal-close-button {
  position: absolute;
  width: 4rem;
  height: 4rem;
  top: 50%;
  right: 1rem;
  transform: translateY(-50%);
  background: transparent;
  color: #aaa;
}
.monitor-image {
  width: 8rem;
  height: 8rem;
}
.monitor-information {
  flex: 1;
}
.monitor-information-title,
.monitor-information-detail {
  margin: 0;
}
.monitor-information-title {
  font-size: 1.2rem;
}
.monitor-information-detail {
  font-size: 1.6rem;
}
.monitor-information-item {
  margin-top: 1.5rem;
}
.attention-note {
  text-align: center;
  font-size: 1.6rem;
  color: #222;
  margin-top: 1rem;
  padding-block: 2rem;
}
.modal-footer {
  display: flex;
  justify-content: space-between;
  padding: 2rem;
  gap: 1rem;
}
.cancel-button {
  width: 12rem;
  height: 5rem;
}
.delete-button {
  height: 5rem;
  flex: 1;
}
</style>
